import { render, staticRenderFns } from "./wxpay_jsapi.vue?vue&type=template&id=f268c096&scoped=true&"
import script from "./wxpay_jsapi.vue?vue&type=script&lang=js&"
export * from "./wxpay_jsapi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f268c096",
  null
  
)

export default component.exports